import React from "react";
import { useNavigate } from "react-router-dom";
import MOCK_MODULES from "../../../mockData/mockModuleData";

// Aggregate total sqft per property
const propertyTotals = Object.values(
  MOCK_MODULES.reduce((acc, mod) => {
    if (!acc[mod.property]) {
      acc[mod.property] = { property: mod.property, totalSqft: 0 };
    }
    acc[mod.property].totalSqft += mod.sqft;
    return acc;
  }, {}),
);

const BuildingInProduction = () => {
  const navigate = useNavigate();

  const handleRowClick = (workOrder) => {
    // Navigate to Module Metrics page with workOrder as URL param
    navigate(`/module-metrics?workOrder=${encodeURIComponent(workOrder)}`);
  };

  return (
    <>
      <p className="modal-description">
        Detailed breakdown of properties currently in production
      </p>

      <div className="modal-section modal-section--scroll">
        <h3>Properties and Total Square Footage</h3>
        <div className="modal-table-scroll">
          <table className="modal-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Total Sq Ft in Progress</th>
              </tr>
            </thead>
            <tbody>
              {propertyTotals.map((row) => (
                <tr key={row.property}>
                  <td>{row.property}</td>
                  <td>{row.totalSqft.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="modal-section modal-section--scroll">
        <h3>Items in Production</h3>
        <div className="modal-table-scroll">
          <table className="modal-table modal-table--clickable">
            <thead>
              <tr>
                <th>Property</th>
                <th>Work Order</th>
                <th>Sq Ft Per Item</th>
              </tr>
            </thead>
            <tbody>
              {MOCK_MODULES.map((mod) => (
                <tr
                  key={mod.workOrder}
                  onClick={() => handleRowClick(mod.workOrder)}
                  className="modal-table-row--clickable"
                  title="Click to view module details"
                >
                  <td>{mod.property}</td>
                  <td>{mod.workOrder}</td>
                  <td>{mod.sqft.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default BuildingInProduction;
